<div class="innerpage-fullwithbanner">
  <h2 class="bighead">Off-Market Deal Approvals</h2>
  <ul class="bread-crumbs">
    <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
    <li>Portfolio Inquiries<span style="padding:8px;">|</span></li>
    <li>Off-Market Deal Approvals</li>
  </ul>
</div>
<div class="container container-lg section-margin min-heightcontainer p_1">
  <div class="border-div table-fixed margin0">
    <div class="d-flex bov-filter">
      <div class="mr-auto">
        <div class="form-group" *ngIf="authService.Admin()||authService.SuperAdmin()">
          <ul class="statuslisting ">

            <li class="transition">
              <a href="javascript:void(0);">

              </a>
              <div class="displayinlineblockdiv">
                <a href="javascript:void(0);">
                  <h4>{{InquiryTotal}} Off-Market Approvals In Progress</h4>
                </a>
                <h5>
                  <a href="javascript:void(0);" [class.active]="status === 'New'" (click)="setFilter('New')"><span style="color:#e47220">{{New ? New : 0}}</span> New</a>
                  <a href="javascript:void(0);" [class.active]="status === 'Contacted'" (click)="setFilter('Contacted')"><span style="color:#28a436">{{Contacted ? Contacted : 0}}</span> Contacted</a>
                </h5>
              </div>
            </li>

            <li class="transition">
              <a href="javascript:void(0);">

              </a>
              <div class="displayinlineblockdiv">
                <a href="javascript:void(0);">
                  <h4>{{TotalProperties}} Properties Created</h4>
                </a>
                <h5>
                  <a href="javascript:void(0);" [class.active]="status === 'Off-Market'" (click)="setFilter('Off-Market')"><span style="color:#28a436">{{OffMarket ? OffMarket : 0}}</span> Off- Market</a>
                  <a href="javascript:void(0);" [class.active]="status === 'Others'" (click)="setFilter('Others')"><span style="color:#28a436">{{Others ? Others : 0}}</span> Others</a>
                </h5>
              </div>
            </li>

            <li class="transition">
              <a href="javascript:void(0);">

              </a>
              <div class="displayinlineblockdiv">
                <a href="javascript:void(0);">
                  <h4>Canceled</h4>
                </a>
                <h5>
                  <a href="javascript:void(0);" [class.active]="status === 'Cancelled'" (click)="setFilter('Cancelled')"><span style="color:#e47220">{{Cancelled ? Cancelled : 0}}</span> </a>
                </h5>
              </div>
            </li>

            <!--<li class="transition" style="border: 1px solid #d8d0d0;min-height:85px;" (click)="setFilter('Cancelled')">
      <h4>Cancelled</h4>
      <a href="javascript:void(0);" style="display:block;">
          <h4 style="color:black;background: #edf2f5;"><span style="color:red;"></span></h4>
      </a>
  </li>-->
            <li class="transition link-btn-li" style="border:0 !important;">
              <a class="bluelinkunderline" href="javascript:void(0);" (click)="reset()">View All</a>
            </li>
          </ul>
        </div>

      </div>
      <div>
        <div class="d-flex align-item-center justify-content-end  floatinghead-right margin-bottom-15" id="divBOVAdvance">
          <div class="search-sec  be-search-01 d-flex margin-right-15 margin-bottom-15">
            <input class="form-control" type="text" [(ngModel)]="filter" (keyup)="search()" placeholder="Search..">
            <i class="fa fa-search icon" aria-hidden="true"></i>
          </div>
          <div id="divAdvanceBlock" *ngIf="authService.Admin()||authService.SuperAdmin()" class="btn-group select-dropdown  clearfix right-border margin-right-15 margin-bottom-15" dropdown #dropdown="bs-dropdown" [autoClose]="false">
            <button dropdownToggle type="button" id="btnAdvanceBlock" [class]="((Validation.IsNull(advanceFilter.TenantName)
                                +Validation.IsNull(advanceFilter.BrokerName)
                                +Validation.IsNull(advanceFilter.Principal)
                                +Validation.IsNull(advanceFilter.Date))  =='') && !advanceFilter.StatusId && advanceFilter.PropertyType == 0 ? 'margin-right-10 btn box-advacned-search margin-left-10' : 'margin-right-10 btn box-advacned-search margin-left-10 selected-btn-advance'" area-expanded="true">
              Advanced Filters<span class="caret"></span>
            </button> 
            <div (blur)="dp.hide()" *dropdownMenu id="dropdown-triggers-manual" class="dropdown-menu dropdown-div portfolio-approval-div mega-dropdown advanced-serch-dropdown dropdown-menu-right" (click)="$event.stopPropagation()">
              <div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label class="form-label">Tenant Name</label>
                          <input placeholder="Tenant Name" (focus)="dp.hide()" [class]=" Validation.IsNull(advanceFilter.TenantName) == '' ? 'form-control' :'form-control advance-filter-active'" #name="ngModel" maxlength="100" [(ngModel)]="advanceFilter.TenantName" required type="text">
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label class="form-label">Principal</label>
                          <input placeholder="Principal" (focus)="dp.hide()" [class]=" Validation.IsNull(advanceFilter.Principal) == '' ? 'form-control' :'form-control advance-filter-active'" #name="ngModel" maxlength="100" [(ngModel)]="advanceFilter.Principal" required type="text">
                        </div>
                      </div>
                    </div>
                    <div class="row margin-top-15">

                      <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label class="form-label">Status</label>
                          <label class="select">
                            <select (focus)="dp.hide()" [class]="!advanceFilter.StatusId ? 'form-control' :'form-control advance-filter-active'" #state="ngModel" [(ngModel)]="advanceFilter.StatusId">
                              <option value=null>--Select--</option>
                              <option *ngFor="let stype of statusList" [(ngValue)]="stype.id">{{stype.description}}</option>
                            </select>
                            <i></i>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label class="form-label">Request Date</label>
                          <div class="textbox-date">
                            <input placeholder="Request Date" #dp="bsDatepicker" bsDatepicker [class]=" Validation.IsNull(advanceFilter.Date) == '' ? 'form-control' :'form-control advance-filter-active'" type="text" (change)="onDateSelect();dropdown.show()" [(ngModel)]="advanceFilter.Date">
                            <i class="icofont icofont-ui-calendar icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
                <div class="text-right margin-top-15 d-flex btn-search-btm align-item-center" style="justify-content:flex-end;">
                  <button class="btn btn-default btn-lg" (click)="onClearFilter(1);dropdown.hide();dp.hide()">Reset</button>
                  <button class="btn btn-border btn-success btn-lg" (click)="onSearch();dropdown.hide();dp.hide()">Search</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
        <thead>
          <tr>
            <th [hidden]="!authService.Admin()&&!authService.SuperAdmin()" data-orderable="false">Action</th>
            <th [hidden]="true"></th>
            <th>Tenant</th>
            <th>Prospects</th>
            <th class="whitespacenowrap">Request Date</th>
            <th>City / State</th>
            <th>Status</th>
            <th>Property Created</th>
            <th>Broker</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let bov of bovList;let p = index">
            <td class="first-td" [hidden]="true"></td>
            <td class="whitespacenowrap">
              <div class="d-flex">
              <a *ngIf="bov.PropertyGuid" href="javascript:void(0);" (click)="openAssignBrokerModal(BOVList,'panlestyle add-news-modal',bov.Id, bov.PropertyId)" class="remove" tooltip="Assign Broker" placement="right">
                <i class="fa fa-user-plus" aria-hidden="true"></i>
              </a>
              <div class="btn-group rightdropdown mr-5" dropdown *ngIf="(authService.Admin()||authService.SuperAdmin()) && !bov.PropertyId">
                <button id="button-basic" dropdownToggle type="button" class="blueone dropdown-toggle"
                        aria-controls="dropdown-basic" placement="right" tooltip="Action" container="body">
                  <i class="fa fa-cog" aria-hidden="true"></i>
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModal($event,ApproveTenant,bov.Id,'deletemodal',actions.ApproveTenant)" *ngIf="(!bov.TenantId > 0||(bov.GuarantorName!=null&&!bov.GuarantorId>0))">Approve Tenant/Guarantor</a></li>
                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModal($event,Approve,bov.Id,'deletemodal',actions.Approve)">Approve and Create Property</a></li>
                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModal($event,Reject,bov.Id,'panlestyle',actions.Reject)">Reject</a></li>
                </ul>
              </div>
              <!--<a href="javascript:void(0);" class="blueone" *ngIf="authService.Admin() && !bov.PropertyId" [hidden]="true" tooltip="Quick Edit" (click)="openModalForQuickEdit(QuickEdit,'panlestyle',row.PropertyGuid,row.State,row.City,row.Brokerage,1)" placement="top" style="line-height:32px;">
                <i class="fa fa-pencil-square-o" style="font-size:18px;margin-left:3px;" aria-hidden="true"></i>
              </a>-->

            </div>


            </td>
            <td class="whitespacenowrap" (click)="redirectOnCellClick(bov.Slug ? bov.Slug : bov.PropertyGuid, bov.Guid)" style="cursor:pointer;">
              <p class="d-flex">
                <a href="javascript:void(0)">
                  {{bov.TenantName?bov.TenantName : 'Not provided'}}
                </a>
              </p>
            </td>
            <td>
              <div>
                <p class="d-flex">
                  {{bov.FirstName}}
                </p>
                {{bov.Phone|phone}}<br />
                {{bov.Email}}
              </div>
             
            </td>
            <td (click)="redirectOnCellClick(bov.Slug ? bov.Slug : bov.PropertyGuid, bov.Guid)" style="cursor:pointer;">
              <p class="d-flex">
                {{bov.Date | date:'MM/dd/yyyy'}}
              </p>
            </td>
            <td> {{bov.City}} {{bov.State?bov.City?(', '+bov.State):bov.State:'-'}}</td>
            <td class="whitespacenowrap">
              <label class="select" *ngIf="authService.Admin()||authService.SuperAdmin()">
                <select class="form-control" id="status" #status [(ngModel)]="bov.ApprovalStatusId" (change)="changeInquiryStatus(bov.Id,bov.ApprovalStatusId)">
                  <option *ngFor="let stype of statusList" [(ngValue)]="stype.id">{{stype.description}}</option>
                </select>
                <i></i>
              </label>
            </td>
            <td class="whitespacenowrap">{{bov.PropertyCreated?bov.PropertyCreated==true?'Yes':'No':'No'}}</td>
            <td class="whitespacenowrap">{{bov.Broker?bov.Broker:'-'}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr *ngIf="bovList?.length == 0&&!IsLoading ">
            <td colspan="8" class="odd no-data-available">
              <div class="nodata">
                <i class="fa fa-exclamation-triangle icon"></i>
                <p>Off-Market Approvals not found.</p>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<ng-template #Approve>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">The Property <b>{{selectedProperty}}</b> will be moved to live listings. Are you sure you want to continue?</h6>

    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefApprove.hide()">CANCEL</button>
      <button class="btn btn-lg btn-success" (click)="changeStatus();">YES</button>
    </div>
  </div>
</ng-template>

<ng-template #ApproveTenant>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to approve Tenant/Guarantor ?</h6>

    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefApprove.hide()">CANCEL</button>
      <button class="btn btn-lg btn-success" (click)="addTenantGuarantor();">YES</button>
    </div>
  </div>
</ng-template>

<ng-template #BOVList>
<app-shared-user-list [modalRef]="modalRefBOVList" [userRoles]="'broker'" (selectedUserEvent)="addBroker($event);" [selectedUserId]="selectedUserId"></app-shared-user-list>
</ng-template>

<ng-template #QuickEdit>
  <app-quick-edit-property [selectedPropertyId]="selectedPropertyId" [quickEditDetails]="quickEditDetails" (closeModal)="closeModal($event)" [isDataEntryProperty]="isDataEntryProperty"></app-quick-edit-property>
</ng-template>

<ng-template #Reject>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Reject Property</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefApprove.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">The Property <b>{{selectedProperty}}</b> will be Rejected. Are you sure you want to continue ?</label>

    </div>
    <div class="form-group">
      <label class="form-label">Comments</label>
      <textarea class="form-control" [(ngModel)]="Comments" maxlength="200" rows="3"></textarea>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefApprove.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="changeStatus();">Reject</button>
    </div>
  </div>
</ng-template>

<ng-template #template class="pull-left">
  <app-audit-trail-details [modalRef]="modalRef" [auditTrailId]="AuditId"></app-audit-trail-details>
</ng-template>
